module.exports = __webpack_public_path__ + "static/media/semitrailer-3.d459c821.png";